import type { IShopper } from '@makemydeal/dr-platform-types';
import type { ConsumerSearchResult } from '../types/search.types';

const NON_DIGIT = /\D/g;

/**
 * Maps a chosen search result onto the participant shape the form seeds from. Every field comes from
 * the result — a consumer change replaces the person, so nothing carries over from the one leaving.
 *
 * `commonConsumerId` is the field apply resolves identity from. Losing it would create a duplicate
 * consumer instead of attaching the existing one.
 */
export const toDraftFromConsumerResult = (
    result: ConsumerSearchResult,
    isPostalCodeDigitsOnlyValidationEnabled?: boolean
): IShopper =>
    ({
        commonConsumerId: result.commonConsumerId,
        title: result.title,
        firstName: result.firstName ?? '',
        middleName: result.middleName,
        lastName: result.lastName ?? '',
        suffix: result.suffix,
        email: result.primaryEmail ?? '',
        emailAlternative: result.alternateEmail,
        phone: result.cellPhone ?? result.primaryPhone ?? '',
        cellPhone: result.cellPhone,
        homePhone: result.homePhone,
        workPhone: result.workPhone,
        streetAddress: result.primaryAddress?.street1,
        streetAddress2: result.primaryAddress?.street2,
        city: result.primaryAddress?.city,
        state: result.primaryAddress?.stateOrProvinceAbbreviation,
        county: result.primaryAddress?.countyOrRegion,
        zip: isPostalCodeDigitsOnlyValidationEnabled
            ? (result.primaryAddress?.postalCode ?? '').replace(NON_DIGIT, '')
            : result.primaryAddress?.postalCode ?? ''
    } as IShopper);
